/** @format */

import { Container } from "../../components/layouts/Container";
import EmochiEconomicEstimateElement from "../../components/ui_elements/emochi/Economic/EconomicEstimateElement";

const EmochiEconomicEstimate = ({ redirect }: { redirect?: boolean }) => {
  return (
    <Container isLogin={true} background={"default"} align={"top"}>
      <EmochiEconomicEstimateElement redirect={redirect} />
    </Container>
  );
};

export default EmochiEconomicEstimate;
